import { render, staticRenderFns } from "./BatchDetails.vue?vue&type=template&id=29765ea9&scoped=true"
import script from "./BatchDetails.vue?vue&type=script&lang=js"
export * from "./BatchDetails.vue?vue&type=script&lang=js"
import style0 from "./BatchDetails.vue?vue&type=style&index=0&id=29765ea9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29765ea9",
  null
  
)

export default component.exports